import styled from '@emotion/styled';

export const SubscriptionWrapper = styled.div`
  margin-bottom: 10px;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  width: fit-content;
  font-size: 12px;
  font-weight: 500;
  gap: 5px;
`;

export const PurchaseOption = styled.div`
  padding: 7px 10px;
  line-height: 100%;
  font-size: 12px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily};
  border: 1px solid #afafaf;
  border-radius: 4px;

  &:not(:last-of-type) {
    margin-bottom: 5px;
  }

  & > div:first-of-type {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const PurchaseOptionMarkerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  cursor: pointer;

  & > p {
    margin-top: 2px;
  }
`;

export const PurchaseOptionMarker = styled.div<{ selected: boolean }>`
  width: 15px;
  height: 15px;
  border-width: ${({ selected }) => (selected ? '2px' : '1px')};
  border-radius: 50%;
  border-style: solid;
  border-color: #000;
  background: ${({ selected, theme }) => (selected ? theme.colors.light : '#fff')};
`;

export const SubscriptionOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 10px;
  gap: 5px;
`;

export const SubscriptionOptionsLabel = styled.p`
  padding-top: 20px;
`;

export const OldPrice = styled.p`
  margin-bottom: 5px !important;
  font-weight: 300;
  text-decoration: line-through;
`;

export const Price = styled.p`
  margin-top: 2px !important;
`;

export const SubscriptionOption = styled.div<{ selected: boolean }>`
  flex: 1 1 30%;
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
  border: 1px solid #afafaf;
  border-radius: 4px;
  background: ${({ selected, theme }) => (selected ? theme.colors.light : 'none')};

  & > p {
    margin-bottom: 2px;
  }

  & > p:first-of-type {
    text-transform: lowercase;
  }

  & > p:last-of-type {
    line-height: 100%;
    font-size: 10px;
    font-weight: 400;
  }
`;
